export default __webpack_public_path__ + "static/media/img-farmer.2aa00f69.svg";